import React, { useState, useEffect } from 'react'
import { useFypdjListQuery } from '../../store/DianShangYeWuApi'
import { Table, Form, Space, Flex } from 'antd'
import classes from './expenseInvoice.module.css' 
import ExpenseListWithId from '../../document/expense/ExpenseListWithId'
import ExpenseInvoiceEdit from './ExpenseInvoiceEdit'
import Icon from '../../cpn/Icon'
import ClientSelect from '../../system/client/ClientSelect'
function ExpenseInvoiceListSubmitted(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);
    const [query, setQuery] = useState({
        "fypdj_kh_id": '',
    });
    const {data, isSuccess} = useFypdjListQuery({
        fypdj_qy_id:props.qy_id,
        fypdj_uid:props.yh_id,
    },{refetchOnMountOrArgChange:1});
    useEffect(() => {
        if (isSuccess) {
            let arr = data.Result;
            if(query.fypdj_kh_id){
                arr = arr.filter((item) => item.fypdj_kh_id === query.fypdj_kh_id);
            }
            setList(arr);
        }
        }, [data, isSuccess, query.fypdj_kh_id]);
    const columns = [
        {
            title: '费用客户',
            dataIndex: 'fypdj_kh_name',
            key: 'fypdj_kh_name',
            render: (text, record) => <ExpenseInvoiceEdit 
                                            fypdj_id={record.fypdj_id} 
                                            yh_id={props.yh_id}
                                            yh_name={props.yh_name}
                                            qy_id={props.qy_id}
                                            qy_name={props.qy_name}
                                            fypdj_kh_name={record.fypdj_kh_name}
                                            fypdj_state={record.fypdj_state}
                                        />
            
        },
        {
            title: '费用票金额',
            dataIndex: 'fypdj_amount',
            key: 'fypdj_amount',
            render: (text, record) => <span style={{color:'#3366FF'}}>￥{Number(text).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
        },
        {
            title: '费用单号    ',
            dataIndex: 'fypdj_ddzc_id',
            key: 'fypdj_ddzc_id',
            render: (text, record) => <ExpenseListWithId id={record.fypdj_ddzc_id} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
        },
        {
            title: '提交记录',
                dataIndex: 'fypdj_ctime',
            key: 'fypdj_ctime',
            render: (text, record) => <span>{text} {record.fypdj_uname}</span>
        },
        {
            title: '编号',
            dataIndex: 'fypdj_id',
            key: 'fypdj_id',
        },
    ]
    return (
        <>
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_expense_invoice_submitted'
                    form={form}
                    initialValues={{                        
                        fypdj_kh_id: query.fypdj_kh_id ? query.fypdj_kh_id : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            
                            fypdj_kh_id: values.fypdj_kh_id ? values.fypdj_kh_id : '',
                        };
                        
                            localStorage.setItem('jtg-caiwu_expenseInvoiceListSubmitted_fypdj_kh_id', JSON.stringify(serializedValues.fypdj_kh_id));
                        setQuery(prev => ({ 
                            ...prev, 
                            fypdj_kh_id: serializedValues.fypdj_kh_id, 
                        }));
                    }}
                >
                    <ClientSelect
                        onChange={(value) => {
                            setQuery(prev => ({ 
                                ...prev, 
                                fypdj_kh_id: value,                                     
                            }));
                            localStorage.setItem('jtg-caiwu_expenseInvoiceListSubmitted_fypdj_kh_id', JSON.stringify(value));
                        }}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        style={{width:'250px'}}
                            placeholder='选择费用客户'
                        name='fypdj_kh_id'
                    />                                      
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>                           
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                            localStorage.setItem('jtg-caiwu_expenseInvoiceListSubmitted_fypdj_kh_id', JSON.stringify(''))
                                    setQuery({
                                        "fypdj_kh_id": '',                                        
                                    })
                                    form.setFieldsValue({
                                        fypdj_kh_id: null,
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form> 
            </Flex>
            <Table 
                className={classes.orangeHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="fypdj_id"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.fypdj_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={1} colSpan={1}>
                                <span style={{color:'#3366FF'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-3" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
            />
        </>
    )
}

export default ExpenseInvoiceListSubmitted